export type AppletId = 'nsight' | 'arva' | 'saye-saman';

export const APPLET_IDS: AppletId[] = ['nsight', 'arva', 'saye-saman'];

export const DEFAULT_APPLET_ID: AppletId = 'nsight';

export const APP_TEMPLATE_STORAGE_KEY = 'appTemplate';

export function isAppletId(value: string | null | undefined): value is AppletId {
  return Boolean(value && (APPLET_IDS as string[]).includes(value));
}

export function normalizeAppletId(value: unknown): AppletId {
  if (typeof value !== 'string') return DEFAULT_APPLET_ID;
  const id = value.trim();
  return isAppletId(id) ? id : DEFAULT_APPLET_ID;
}

export function extractTenantTemplateType(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;
  const payload = data as Record<string, any>;
  const raw =
    payload.template_type ??
    payload.templateType ??
    payload.company?.template_type ??
    payload.company?.templateType;
  if (typeof raw !== 'string' || !raw.trim()) return null;
  return raw.trim();
}

export function extractCompanyLogo(data: unknown): unknown {
  if (!data || typeof data !== 'object') return null;
  const payload = data as Record<string, any>;
  return payload.company_logo ?? payload.company?.logo ?? null;
}

export function persistAppletId(id: AppletId) {
  try {
    localStorage.setItem(APP_TEMPLATE_STORAGE_KEY, id);
  } catch {
    // ignore
  }
}

export function readCachedAppletId(): AppletId {
  try {
    const stored = localStorage.getItem(APP_TEMPLATE_STORAGE_KEY);
    if (isAppletId(stored)) return stored;
  } catch {
    // ignore
  }

  try {
    const raw = localStorage.getItem('tenant_config');
    if (raw) {
      const fromTenant = extractTenantTemplateType(JSON.parse(raw));
      if (fromTenant) return normalizeAppletId(fromTenant);
    }
  } catch {
    // ignore
  }

  return DEFAULT_APPLET_ID;
}
